// extracted by mini-css-extract-plugin
export default {"titleContainer":"TopPicksContainer_titleContainer__FeS78"};